import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/resumo-compra',
  component: DashBoardNav,
    children: [{
      path: '/resumo-compra',
      component: () => import('@/components/compra/resumoCompra')
    }
  ]
}]
